import React from 'react';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import "./gallery.css";
 
class Gallery extends React.Component {
 
  render() {
 
    const images = [
      {
        original: '/assets/cover/gallery01.jpg',
        thumbnail: '/assets/cover/thumbnail-gallery-01.jpg'
      },
      {
        original: '/assets/cover/gallery02.jpg',
        thumbnail: '/assets/cover/thumbnail-gallery-02.jpg'
      },
      {
        original: '/assets/cover/gallery03.jpg',
        thumbnail: '/assets/cover/thumbnail-gallery-03.jpg'
      },
      {
        original: '/assets/cover/gallery04.jpg',
        thumbnail: '/assets/cover/thumbnail-gallery-04.jpg'
      },
      {
        original: '/assets/cover/gallery05.jpg',
        thumbnail: '/assets/cover/thumbnail-gallery-05.jpg'
      },
      {
        original: '/assets/cover/gallery06.jpg',
        thumbnail: '/assets/cover/thumbnail-gallery-06.jpg'
      },
      {
        original: '/assets/cover/gallery07.jpg',
        thumbnail: '/assets/cover/thumbnail-gallery-07.jpg'
      },
      {
        original: '/assets/cover/gallery08.jpg',
        thumbnail: '/assets/cover/thumbnail-gallery-08.jpg'
      },
      {
        original: '/assets/cover/gallery09.jpg',
        thumbnail: '/assets/cover/thumbnail-gallery-09.jpg'
      },
      {
        original: '/assets/cover/gallery10.jpg',
        thumbnail: '/assets/cover/thumbnail-gallery-10.jpg'
      },
      {
        original: '/assets/cover/gallery11.jpg',
        thumbnail: '/assets/cover/thumbnail-gallery-11.jpg'
      },


      {
        original: '/assets/cover/gallery16-min.jpg',
        thumbnail: '/assets/cover/gallery16-min.jpg'
      }
    ]
 
    return (
      <div id="gallery">
        <h2>Galéria</h2>
        <ImageGallery items={images} useBrowserFullscreen={false} showFullscreenButton={false} showPlayButton={false} />
      </div>
    );
  }

}
export default Gallery;